import api from './api';
import {
    Parameter,
    Response,
} from '../dtos';

const findAllParameters = async (): Promise<Parameter | null> => {
    const { data } = await api.get<Response<Parameter>>('parameter');

    if (Object.keys(data).length === 0 || Object.keys(data.data).length === 0)
        return null;

    return data.data;
};

export { findAllParameters };